import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Svg } from '../../1_Atoms/Svg/Svg';
import PropTypes from 'prop-types';

export const Modal = ({modalContent, isOpen, modalId, handleClose, ...props }) => {
    const [isModalOpen, setIsModalOpen] = React.useState(isOpen);
    return (
        <div className="mz-modal modal" id={modalId} aria-hidden={!isOpen}>
            <div className="wrapper">
                <div className="mz-modal__container">
                    <div className="mz-modal__content">
                        <button className="mz-modal__close" aria-label="Close Modal" onClick={() => {
							document.querySelector('body').classList.remove('disabled');
							handleClose(false)
						}}>
                            <Svg
                                colour="grey"
                                size={1.93}
                                svg_list="x"
                            />
                        </button>
                        <div className="mz-modal__text-container">
                            { ReactHtmlParser (modalContent) }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Modal.propTypes = {
    HandleTabClick: PropTypes.func,
}

Modal.defaultProps = {
    handleClose: () => {
    },
};